import React, { useEffect, useState } from "react";
import "../AdminPanel.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import SuperAdminSidebar from "../SuperAdminSidebar";
import ManagerSidebar from "../ManagerSidebar";
import LeaderSidebar from "../LeaderSidebar";
import MemberSidebar from "../MemberSidebar";
import AdminNavbar from './AdminNavbar';

const AddVehicle = () => {
  const navigate = useNavigate();
  const [userType, setUserType] = useState("");
  const [userName, setUserName] = useState("");
  const [userFullName, setUserFullName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const storedUserType = localStorage.getItem("usertype");
    const storedUserName = localStorage.getItem("userName");
    const storedFName = localStorage.getItem("fname");
    const storedLName = localStorage.getItem("lname");

    console.log(storedUserType);
    if (!storedUserType) {
      navigate("/sign-in");
    } else {
      setUserType(storedUserType);
      setUserName(storedUserName);
      if (storedFName && storedLName) {
        setUserFullName(`${storedFName} ${storedLName}`);
      } else if (storedFName) {
        setUserFullName(storedFName);
      } else {
        setUserFullName(storedUserName);
      }
    }
  }, [navigate]);

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("userName");
    localStorage.removeItem("usertype");
    localStorage.removeItem("fname");
    localStorage.removeItem("lname");
    navigate("/sign-in");
  };

  const [formData, setFormData] = useState({
    maker: "",
    model: "",
    year: "",
    price: "",
    country: "",
    mileage: "",
    fuel: "",
    transmission: "",
    drive: "",
    version: "",
    engine: "",
    location: "",
    steering: "",
    seats: "",
    doors: "",
    dimension: "",
    m3: "",
    weight: "",
    color: "",
    stockId: "",
    vin: "",
    bodyType: "",
    salePercent: "",
    activationDate: "",
    features: {
      abs: false,
      airbag: false,
      bluetooth: false,
      cdPlayer: false,
      dvd: false,
      tv: false,
      powerSteering: false,
      powerWindow: false,
      sunRoof: false,
      leatherSeat: false,
      alloyWheels: false,
      ac: false,
      radio: false,
      caChanger: false,
      powerSeat: false,
      backTire: false,
      grillGuard: false,
      rearSpoiller: false,
      centralLock: false,
      jack: false,
      spareTire: false,
      wheelSpanner: false,
      fogLights: false,
      backCamera: false,
      pushStart: false,
      keylessEntry: false,
      esc: false,
      cam360deg: false,
      bodyKit: false,
      sideAirbag: false,
      powerMirror: false,
      sideSkirts: false,
      frontLip: false,
      navigation: false,
      turbo: false,
      powerDoor: false,
    },
    mainImage: null,
    galleryImages: [],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFeatureChange = (e) => {
    const { name, checked } = e.target;
    setFormData({
      ...formData,
      features: {
        ...formData.features,
        [name]: checked,
      },
    });
  };

  const handleSelectAllFeatures = (e) => {
    const { checked } = e.target;
    setFormData({
      ...formData,
      features: {
        abs: checked,
        airbag: checked,
        bluetooth: checked,
        cdPlayer: checked,
        dvd: checked,
        tv: checked,
        powerSteering: checked,
        powerWindow: checked,
        sunRoof: checked,
        leatherSeat: checked,
        alloyWheels: checked,
        ac: checked,
        radio: checked,
        caChanger: checked,
        powerSeat: checked,
        backTire: checked,
        grillGuard: checked,
        rearSpoiller: checked,
        centralLock: checked,
        jack: checked,
        spareTire: checked,
        wheelSpanner: checked,
        fogLights: checked,
        backCamera: checked,
        pushStart: checked,
        keylessEntry: checked,
        esc: checked,
        cam360deg: checked,
        bodyKit: checked,
        sideAirbag: checked,
        powerMirror: checked,
        sideSkirts: checked,
        frontLip: checked,
        navigation: checked,
        turbo: checked,
        powerDoor: checked,
      },
    });
  };

  const handleMainImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      console.log("Main image selected:", file.name, file.type);
      if (!file.type.startsWith("image/")) {
        alert("Please select a valid image file.");
        return;
      }
      setFormData({
        ...formData,
        mainImage: file,
      });
    } else {
      console.log("No file selected");
    }
  };

  const handleGalleryImageChange = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = files.filter(file => file.type.startsWith("image/"));
    if (validFiles.length !== files.length) {
      alert("Some files are not valid images and were ignored.");
    }
    setFormData({
      ...formData,
      galleryImages: validFiles,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.mainImage) {
      alert("Error: No main image uploaded or file error.");
      setIsSubmitting(false);
      return;
    }

    setIsSubmitting(true);

    const data = new FormData();
    data.append("maker", formData.maker);
    data.append("model", formData.model);
    data.append("year", formData.year);
    data.append("price", formData.price);
    data.append("country", formData.country);
    data.append("mileage", formData.mileage);
    data.append("fuel", formData.fuel);
    data.append("transmission", formData.transmission);
    data.append("drive", formData.drive);
    data.append("engine", formData.engine);
    data.append("location", formData.location);
    data.append("steering", formData.steering);
    data.append("seats", formData.seats);
    data.append("doors", formData.doors);
    data.append("weight", formData.weight);
    data.append("color", formData.color);
    data.append("vin", formData.vin);
    data.append("body_type", formData.bodyType);
    data.append("salePercent", formData.salePercent);
    data.append("activationDate", formData.activationDate);
    data.append("features", JSON.stringify(formData.features));
    data.append("main_image", formData.mainImage);
    formData.galleryImages.forEach((image) => {
      data.append("gallery_images[]", image);
    });

    for (let pair of data.entries()) {
      console.log(`${pair[0]}: ${pair[1]}`);
    }

    try {
      const response = await axios.post("https://skcapi.btcjapan.co/add_vehicle.php", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      console.log("API Response:", response.data);
      if (response.data.success) {
        alert("Car details uploaded successfully!");
        setFormData({
          maker: "",
          model: "",
          year: "",
          price: "",
          country: "",
          mileage: "",
          fuel: "",
          transmission: "",
          drive: "",
          engine: "",
          location: "",
          steering: "",
          seats: "",
          doors: "",
          weight: "",
          color: "",
          vin: "",
          bodyType: "",
          salePercent: "",
          activationDate: "",
          features: {
            abs: false,
            airbag: false,
            bluetooth: false,
            cdPlayer: false,
            dvd: false,
            tv: false,
            powerSteering: false,
            powerWindow: false,
            sunRoof: false,
            leatherSeat: false,
            alloyWheels: false,
            ac: false,
            radio: false,
            caChanger: false,
            powerSeat: false,
            backTire: false,
            grillGuard: false,
            rearSpoiller: false,
            centralLock: false,
            jack: false,
            spareTire: false,
            wheelSpanner: false,
            fogLights: false,
            backCamera: false,
            pushStart: false,
            keylessEntry: false,
            esc: false,
            cam360deg: false,
            bodyKit: false,
            sideAirbag: false,
            powerMirror: false,
            sideSkirts: false,
            frontLip: false,
            navigation: false,
            turbo: false,
            powerDoor: false,
          },
          mainImage: null,
          galleryImages: [],
        });
        document.querySelector('input[name="mainImage"]').value = "";
        document.querySelector('input[name="galleryImages"]').value = "";
      } else {
        alert("Error: " + (response.data.message || "Unknown error occurred"));
        setErrorMessage(response.data.message || "Unknown error occurred");
      }
    } catch (error) {
      console.error("Upload Error:", error.response ? error.response.data : error.message);
      alert("Error: Failed to upload car details. Check console for details.");
      setErrorMessage("Failed to upload car details. Check console for details.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
      <div className="admin-container">
        <div className="sidebar-container">
          {userType === "administrator" && <SuperAdminSidebar />}
          {userType === "leader" && <LeaderSidebar />}
          {userType === "manager" && <ManagerSidebar />}
          {userType === "member" && <MemberSidebar />}
        </div>

        <div className="admin-content">
          {/* Use the new AdminNavbar component */}
          <AdminNavbar />

          <div className="main-section">
            <h3 className="section-title">Add New Vehicle</h3>

            <form onSubmit={handleSubmit} className="p-4 border rounded">
              <div className="row mb-3">
                <div className="col-md-3">
                  <label style={{ color: "red", fontSize: "20px" }}>*</label>
                  <input className="form-control" type="text" name="maker" value={formData.maker} onChange={handleChange} placeholder="Maker" />
                </div>
                <div className="col-md-3">
                  <label style={{ color: "red", fontSize: "20px" }}>*</label>
                  <input className="form-control" type="text" name="model" value={formData.model} onChange={handleChange} placeholder="Model" />
                </div>
                <div className="col-md-3">
                  <label style={{ color: "red", fontSize: "20px" }}>*</label>
                  <input className="form-control" type="number" name="year" value={formData.year} onChange={handleChange} placeholder="Year" />
                </div>
                <div className="col-md-3">
                  <label style={{ color: "red", fontSize: "20px" }}>*</label>
                  <input className="form-control" type="number" name="price" value={formData.price} onChange={handleChange} placeholder="Price" />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-3">
                  <label style={{ color: "red", fontSize: "20px" }}>*</label>
                  <input className="form-control" type="text" name="country" value={formData.country} onChange={handleChange} placeholder="Sales Country" />
                </div>
                <div className="col-md-3">
                  <label style={{ color: "red", fontSize: "20px" }}>*</label>
                  <input className="form-control" type="text" name="mileage" value={formData.mileage} onChange={handleChange} placeholder="Mileage" />
                </div>
                <div className="col-md-3">
                  <label style={{ color: "red", fontSize: "20px" }}></label>
                  <input className="form-control" type="text" name="fuel" value={formData.fuel} onChange={handleChange} placeholder="Fuel" />
                </div>
                <div className="col-md-3">
                  <label style={{ color: "red", fontSize: "20px" }}></label>
                  <input className="form-control" type="text" name="transmission" value={formData.transmission} onChange={handleChange} placeholder="Transmission" />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-3">
                  <label style={{ color: "red", fontSize: "20px" }}></label>
                  <input className="form-control" type="text" name="drive" value={formData.drive} onChange={handleChange} placeholder="Drive" />
                </div>
                <div className="col-md-3">
                  <label style={{ color: "red", fontSize: "20px" }}></label>
                  <input className="form-control" type="text" name="engine" value={formData.engine} onChange={handleChange} placeholder="Engine" />
                </div>
                <div className="col-md-3">
                  <label style={{ color: "red", fontSize: "20px" }}></label>
                  <input className="form-control" type="text" name="location" value={formData.location} onChange={handleChange} placeholder="Location" />
                </div>
                <div className="col-md-3">
                  <label style={{ color: "red", fontSize: "20px" }}></label>
                  <input className="form-control" type="text" name="steering" value={formData.steering} onChange={handleChange} placeholder="Steering" />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-3">
                  <label style={{ color: "red", fontSize: "20px" }}></label>
                  <input className="form-control" type="text" name="seats" value={formData.seats} onChange={handleChange} placeholder="Seats" />
                </div>
                <div className="col-md-3">
                  <label style={{ color: "red", fontSize: "20px" }}></label>
                  <input className="form-control" type="text" name="doors" value={formData.doors} onChange={handleChange} placeholder="Doors" />
                </div>
                <div className="col-md-3">
                  <label style={{ color: "red", fontSize: "20px" }}>*</label>
                  <input className="form-control" type="text" name="weight" value={formData.weight} onChange={handleChange} placeholder="Exterior Color" />
                </div>
                <div className="col-md-3">
                  <label style={{ color: "red", fontSize: "20px" }}>*</label>
                  <input className="form-control" type="text" name="color" value={formData.color} onChange={handleChange} placeholder="Interior Color" />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-3">
                  <label style={{ color: "red", fontSize: "20px" }}></label>
                  <input className="form-control" type="text" disabled name="stockId" value={formData.stockId} onChange={handleChange} placeholder="Stock ID" />
                </div>
                <div className="col-md-3">
                  <label style={{ color: "red", fontSize: "20px" }}></label>
                  <input className="form-control" type="text" name="vin" value={formData.vin} onChange={handleChange} placeholder="Chassis Number" />
                </div>
                <div className="col-md-2">
                  <label style={{ color: "red", fontSize: "20px" }}>*</label>
                  <input className="form-control" type="text" name="bodyType" value={formData.bodyType} onChange={handleChange} placeholder="Body Type" />
                </div>
                <div className="col-md-2">
                  <label style={{ color: "red", fontSize: "20px" }}></label>
                  <input className="form-control" type="text" name="salePercent" value={formData.salePercent} onChange={handleChange} placeholder="Sale percentage" />
                </div>
                <div className="col-md-2">
                  <label style={{ color: "red", fontSize: "20px" }}></label>
                  <input className="form-control" type="date" name="activationDate" value={formData.activationDate} onChange={handleChange} placeholder="Activation Date" />
                </div>
              </div>
              <div className="row mb-3">

                <h5>Features</h5>
                <div className="col-md-2 mb-3">
                  <div className="form-check">
                    <input className="form-check-input" type="checkbox" name="selectAll" onChange={handleSelectAllFeatures} />
                    <label className="form-check-label">Select All</label>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="abs" checked={formData.features.abs} onChange={handleFeatureChange} />
                      <label className="form-check-label">ABS</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="airbag" checked={formData.features.airbag} onChange={handleFeatureChange} />
                      <label className="form-check-label">Airbag</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="bluetooth" checked={formData.features.bluetooth} onChange={handleFeatureChange} />
                      <label className="form-check-label">Bluetooth</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="cdPlayer" checked={formData.features.cdPlayer} onChange={handleFeatureChange} />
                      <label className="form-check-label">CD Player</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="powerSteering" checked={formData.features.powerSteering} onChange={handleFeatureChange} />
                      <label className="form-check-label">Power Steering</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="dvd" checked={formData.features.dvd} onChange={handleFeatureChange} />
                      <label className="form-check-label">DVD</label>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="powerWindow" checked={formData.features.powerWindow} onChange={handleFeatureChange} />
                      <label className="form-check-label">Power Window</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="sunRoof" checked={formData.features.sunRoof} onChange={handleFeatureChange} />
                      <label className="form-check-label">Sun Roof</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="leatherSeat" checked={formData.features.leatherSeat} onChange={handleFeatureChange} />
                      <label className="form-check-label">Leather Seat</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="alloyWheels" checked={formData.features.alloyWheels} onChange={handleFeatureChange} />
                      <label className="form-check-label">Alloy Wheels</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="ac" checked={formData.features.ac} onChange={handleFeatureChange} />
                      <label className="form-check-label">A/C</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="radio" checked={formData.features.radio} onChange={handleFeatureChange} />
                      <label className="form-check-label">Radio</label>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="caChanger" checked={formData.features.caChanger} onChange={handleFeatureChange} />
                      <label className="form-check-label">CD Changer</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="powerSeat" checked={formData.features.powerSeat} onChange={handleFeatureChange} />
                      <label className="form-check-label">Power Seat</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="backTire" checked={formData.features.backTire} onChange={handleFeatureChange} />
                      <label className="form-check-label">Back Tire</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="grillGuard" checked={formData.features.grillGuard} onChange={handleFeatureChange} />
                      <label className="form-check-label">Grill Guard</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="rearSpoiller" checked={formData.features.rearSpoiller} onChange={handleFeatureChange} />
                      <label className="form-check-label">Rear Spoiller</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="centralLock" checked={formData.features.centralLock} onChange={handleFeatureChange} />
                      <label className="form-check-label">Central Lock</label>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="jack" checked={formData.features.jack} onChange={handleFeatureChange} />
                      <label className="form-check-label">Jack</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="spareTire" checked={formData.features.spareTire} onChange={handleFeatureChange} />
                      <label className="form-check-label">Spare Tire</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="wheelSpanner" checked={formData.features.wheelSpanner} onChange={handleFeatureChange} />
                      <label className="form-check-label">Wheel Spanner</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="fogLights" checked={formData.features.fogLights} onChange={handleFeatureChange} />
                      <label className="form-check-label">Fog Lights</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="backCamera" checked={formData.features.backCamera} onChange={handleFeatureChange} />
                      <label className="form-check-label">Back Camera</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="pushStart" checked={formData.features.pushStart} onChange={handleFeatureChange} />
                      <label className="form-check-label">Push Start</label>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="keylessEntry" checked={formData.features.keylessEntry} onChange={handleFeatureChange} />
                      <label className="form-check-label">Keyless Entry</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="esc" checked={formData.features.esc} onChange={handleFeatureChange} />
                      <label className="form-check-label">ESC</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="cam360deg" checked={formData.features.cam360deg} onChange={handleFeatureChange} />
                      <label className="form-check-label">360 Degree Camera</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="bodyKit" checked={formData.features.bodyKit} onChange={handleFeatureChange} />
                      <label className="form-check-label">Body Kit</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="sideAirbag" checked={formData.features.sideAirbag} onChange={handleFeatureChange} />
                      <label className="form-check-label">Side Airbag</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="tv" checked={formData.features.tv} onChange={handleFeatureChange} />
                      <label className="form-check-label">TV</label>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="powerMirror" checked={formData.features.powerMirror} onChange={handleFeatureChange} />
                      <label className="form-check-label">Power Mirror</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="sideSkirts" checked={formData.features.sideSkirts} onChange={handleFeatureChange} />
                      <label className="form-check-label">Side Skirts</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="frontLip" checked={formData.features.frontLip} onChange={handleFeatureChange} />
                      <label className="form-check-label">Front Lip Spoiler</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="navigation" checked={formData.features.navigation} onChange={handleFeatureChange} />
                      <label className="form-check-label">Navigation</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="turbo" checked={formData.features.turbo} onChange={handleFeatureChange} />
                      <label className="form-check-label">Turbo</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" name="powerDoor" checked={formData.features.powerDoor} onChange={handleFeatureChange} />
                      <label className="form-check-label">Power Door</label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Main Image:</label>
                <input
                  type="file"
                  name="mainImage"
                  onChange={handleMainImageChange}
                  className="form-control"
                  accept="image/*"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Gallery Images:</label>
                <input
                  className="form-control"
                  type="file"
                  name="galleryImages"
                  multiple
                  onChange={handleGalleryImageChange}
                  accept="image/*"
                />
              </div>

              {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

              <button type="submit" disabled={isSubmitting} className="btn btn-primary">
                {isSubmitting ? "Submitting..." : "Submit"}
              </button>

            </form>
          </div >
      </div >
    </div >
  );
};

export default AddVehicle;